import { useSection } from './hooks/use-context';

export function Signatures() {
  const { questions } = useSection();

  return (
    <div
      style={{
        fontSize: '10px',
        breakInside: 'avoid',
        display: 'flex',
        gap: '8px',
      }}
    >
      {[
        'b04667cf-bc0d-4c2a-8f8d-79096718b80e',
        'cda38c4f-c9ff-4dc9-87cb-c8f3c661d5ff',
        'b98ea425-f859-4dd9-bfe4-789028ba1064',
      ].map((questionId) => {
        const question = questions.find(
          (question) => question.question_id === questionId,
        );

        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              backgroundColor: '#FFFFFF',
              border: '1px solid #69CC8D',
              padding: '8px',
              minHeight: '200px',
              borderRadius: '3px',
              flex: 1,
            }}
          >
            <div
              style={{
                backgroundColor: '#FAE0CD',
                textAlign: 'center',
                padding: '4px',
                marginBottom: '10px',
                border: '1px solid #69CC8D',
                borderRadius: '5px',
              }}
            >
              {question?.name}
            </div>
            <img
              style={{
                objectFit: 'contain',
                width: '100%',
                height: '100%',
                maxHeight: '300px',
                backgroundColor: '#FFFFFF',
              }}
              src={`${question?.answers?.[0]?.content || ''}`}
              alt="img"
            />
          </div>
        );
      })}
    </div>
  );
}
